<template>
  <div
    class="status-circle"
    :class="[{ 'has-fill': hasFill }, fillClass]"
  ></div>
</template>

<script>
/**
 * @enum {number}
 */
export const StatusCircleFill = {
  NONE: 0,
  LEFT: 1,
  RIGHT: 2,
  FULL: 3,
}

/**
 * A status circle that can be either empty, half filled (to either side) or completely filled.
 */
export default {
  name: 'StatusCircle',
  props: {
    fill: {
      type: Number,
      default: StatusCircleFill.NONE,
      validator: fill => Object.values(StatusCircleFill).includes(fill),
    },
  },
  computed: {
    hasFill() {
      return this.fill !== StatusCircleFill.NONE
    },
    fillClass() {
      switch (this.fill) {
        case StatusCircleFill.LEFT:
          return 'fill-left'
        case StatusCircleFill.RIGHT:
          return 'fill-right'
        case StatusCircleFill.FULL:
          return 'fill-full'
      }

      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.status-circle {
  background-color: $grayLighter;
  border-radius: 100%;
  width: 1.5em;
  height: 1.5em;

  &.has-fill::after {
    content: '';
    display: inline-block;
    box-sizing: border-box;
    background-color: $blueDark;
    height: 100%;
  }

  &.fill-left::after,
  &.fill-right::after {
    width: 50%;
  }

  &.fill-left::after {
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
  }

  &.fill-right::after {
    margin-left: 50%;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
  }

  &.fill-full::after {
    width: 100%;
    border-radius: 50px;
  }
}
</style>
